import * as React from "react";
import { forwardRef } from "react";
const SvgAddicon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentcolor", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.33333 8.66667H0V7.33333H7.33333V0H8.66667V7.33333H16V8.66667H8.66667V16H7.33333V8.66667Z" }));
const ForwardRef = forwardRef(SvgAddicon);
export default ForwardRef;
